// src/components/DiscordSection.jsx
import { useState } from "react";
import { Megaphone, Castle, Sword, Gamepad2, Dumbbell, MessageCircle, ArrowRight } from "lucide-react";
import { useServerStatus } from "../hooks/useServerStatus";

// Discord SVG icon (official shape)
function DiscordIcon({ style }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" style={{ width: 16, height: 16, ...style }}>
      <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
    </svg>
  );
}

const channels = [
  { icon: <Megaphone className="toa-ico-sm" />,      label: "announcements" },
  { icon: <Castle className="toa-ico-sm" />,         label: "general-chat" },
  { icon: <Sword className="toa-ico-sm" />,          label: "minecraft" },
  { icon: <Gamepad2 className="toa-ico-sm" />,       label: "gaming" },
  { icon: <Dumbbell className="toa-ico-sm" />,       label: "fitness-app" },
  { icon: <MessageCircle className="toa-ico-sm" />,  label: "General Voice" },
];

export default function DiscordSection() {
  const [activeChannel, setActiveChannel] = useState(0);
  const { discord, loaded } = useServerStatus();

  const memberDisplay = loaded ? discord.memberCount.toLocaleString() : "...";

  return (
    <div className="toa-dis" id="community">
      <div className="toa-dis-in">
        <div>
          <div className="toa-slbl">Our Home</div>
          <div className="toa-stit">The TOA Discord</div>
          <div className="toa-sdiv" />
          <p className="toa-ssub" style={{ marginBottom: 26 }}>
            The real brotherhood lives here. Thousands of members, dedicated channels, voice events, and a culture
            built on respect and growth. Our Discord is the creed made real.
          </p>
          <a
            href="https://discord.gg/AzrauJnuqw"
            target="_blank"
            rel="noreferrer"
            className="toa-btn toa-btn-p"
            style={{ fontSize: 14, padding: "13px 28px", display: "inline-flex", alignItems: "center", gap: 8 }}
          >
            <DiscordIcon /> Join the Brotherhood
          </a>
        </div>

        <div className="toa-dis-prev">
          <div className="toa-dhdr">
            <div className="toa-dpfp" style={{ background: "none", padding: 0, overflow: "hidden" }}>
              <img src="/toa_discord.png" alt="TOA" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%" }} />
            </div>
            <div>
              <div className="toa-dname">The Ones Above</div>
              <div className="toa-dtime" style={{ display: "flex", alignItems: "center", gap: 5 }}>
                <span style={{
                  display: "inline-block", width: 6, height: 6, borderRadius: "50%", flexShrink: 0,
                  background: loaded && discord.online ? "#4ade80" : "#888",
                  boxShadow: loaded && discord.online ? "0 0 5px #4ade80" : "none",
                }} />
                {memberDisplay} members
              </div>
            </div>
          </div>

          <div className="toa-dchan">
            {channels.map((ch, i) => (
              <div
                key={ch.label}
                className={`toa-ch${activeChannel === i ? " active" : ""}`}
                onClick={() => setActiveChannel(i)}
              >
                {ch.icon} #{ch.label}
              </div>
            ))}
          </div>

          <div className="toa-dmsg">
            <span style={{ color: "#9b7fd4", fontWeight: 600 }}>Member</span>
            <span style={{ fontSize: 11, color: "#72767d", marginLeft: 6 }}>Today at 3:40 PM</span>
            <br />
            Welcome to <span className="toa-hi">The Ones Above</span>.{" "}
            <strong>Rise Above. Grow Together.</strong>{" "}
            <Castle className="toa-ico-sm" style={{ marginLeft: 6, verticalAlign: "middle" }} />
          </div>
        </div>
      </div>
    </div>
  );
}
